import React from "react";
const helpcanvas = {
  display: 'grid',
  gridTemplateColumns: '2fr 3fr 5fr',
  gridTemplateRows: 'min-content 1fr',
  backgroundColor: "#f2f2f2",
  height: '100vh',
  width: '100%',
  rowGap: '24px',
  columnGap: '14px',
  padding: '0 0 14px 0',
};

const helptitle = {
  color: "#222",
  backgroundColor: "#f2f2f2",
  padding: "2px",
  fontFamily: "Arial",
  fontSize: "13px",
};

const helpimg = {
    color: "#222",
    backgroundColor: "#f2f2f2",
    padding: "2px",
    fontFamily: "Arial",
  };

const UIDSProgress = {
    name: 'DS in Progress',
    imageUrl: '../../images/DSProgress.png',
    imageSize: "99%",
    bradius: 20,
  };

const UIDSDSSnapshot = {
    name: 'DS Snapshot',
    imageUrl: '../../images/DSSnapshot.png',
    imageSize: "99%",
    bradius: 20,
  };


export const DSProgress = () => {
  return (
    <div style={helpcanvas}>
      <div
      style={{ marginLeft: "310px" }}
      ></div>
      <div style={helptitle}><b>Data Scans in Progress</b><br/><br/>
      See data sensitivity scans live as they run. Any scan that is currently running live will be 
      displayed in a data scan table similar to the one shown on the right. <br/><br/>
      As a default, the display will show 10 results. However, depending on the volume of scans 
      being performed, there are additional features allowing you to search or apply filters to 
      find the information you need quickly.  <br/>
      <ul style={{marginLeft: '4em'}}>
      <li>No. of scans to display - Click the numeric 10 at the top right and select a different value for the number of scans to be displayed</li>      
      <li>Search box - Type the name of the specific scan you are looking for in the search box to find it quickly </li>
      <li>Set credentials - Select the credential to be used.  </li>
      </ul><br/>
      Pause or Delete Scans <br/>
      Within this display, you can go to the Action column to create an action - either delete a 
      scan or temporarily pause a scan. Pausing a scan allows systems administrators to perform 
      system maintenance tasks on targets that are the current subject of a scan. A scan will be 
      resumed at the completion of the system maintenance. <br/><br/>
      Each scan within the display can be clicked on and expanded, allowing you to view its 
      current performance. Be aware that these results are live, so occasionally counts, grades 
      and findings of files are in transit or partial. <br/><br/>Live views of scans in progress 
      will periodically update to show the most up-to-date progress. In addition, there is a 
      refresh button at the top right of the table shown below that allows you to trigger a 
      data refresh when needed rather than waiting for the auto-refresh time. 
      </div>
      <div style={helpimg}>
      <img
        src={UIDSProgress.imageUrl}
        alt={'Image of ' + UIDSProgress.name}
        style={{
          width: UIDSProgress.imageSize,
          borderRadius: UIDSProgress.bradius,
        }}
      />
      </div>
    </div>
  );
};

export const DSSnapshot = () => {
  return (
    <div style={helpcanvas}>
      <div
      style={{ marginLeft: "310px" }}
      ></div>
      <div style={helptitle}><b>Live Scan Result Snapshot</b><br/><br/>
      Within the scan table, select any live scan to ascertain the following information: <br/>
      <ul style={{marginLeft: '4em'}}>
      <li>Quick snapshot of the scan results so far - illustrating the percentage breakdown of 
      sensitive versus non-sensitive data discovered within your scan, the number of files 
      scanned, the number of bytes scanned, and the scan risk grade </li><br/>
      <li>Categories searched - what categories were searched during the data scan. This 
      could be passport numbers, passwords, bank accounts, credit cards or other categories. 
      Essentially, this is retrieved from the information selected when creating a data scan. </li></ul><br/>
      
      </div>
      <div style={helpimg}>
      <img
        src={UIDSDSSnapshot.imageUrl}
        alt={'Image of ' + UIDSDSSnapshot.name}
        style={{
          width: UIDSDSSnapshot.imageSize,
          borderRadius: UIDSDSSnapshot.bradius,
        }}
      />
      </div>
    </div>
  );
};

